import {
    Component,
    Host,
    h,
    Event,
    Prop,
    Watch,
    State,
} from "@stencil/core";
import type { EventEmitter } from "@stencil/core";

import {
    INPUT_MAX_LENGTH,
    INPUT_PLACEHOLDER,
} from "../../../../../global/variables";

@Component({
    tag: "c-form-text",
    styleUrl: "c-form-text.scss",
})
export class CFormText {
    defaultPlaceholder = INPUT_PLACEHOLDER;
    inputElement: HTMLInputElement;
    @Event() inputText: EventEmitter<string>;
    @State() emptyUserInput = false;
    @State() longUserInput = false;
    @Prop() formName: string;
    @Prop() germanTitle?: string;
    @Prop() infoString?: string;
    @Prop() disabled = false;
    @Prop() placeholder;
    @Watch("disabled")
    watchHandler(disabled: boolean): void {
        if (!disabled) {
            setTimeout(() => this.inputElement.focus(), 0);
        }
    }

    handleKeyUpdate(e: any) {
        if (e.key === "Enter") {
            this.processInput();
        } else if (this.emptyUserInput) {
            this.emptyUserInput = false;
        }
    }

    handleButtonClick() {
        this.processInput();
    }

    // Check if the user input is too long (live check)
    validateInput() {
        const input = this.inputElement.value;
        if (input.length > INPUT_MAX_LENGTH) {
            this.emptyUserInput = false;
            this.longUserInput = true;
        } else if (this.longUserInput) {
            this.longUserInput = false;
        }
    }

    processInput() {
        if (this.longUserInput) {
            this.inputElement.focus();
            return;
        }
        // Check if the message is not empty before sending it to the bot
        this.inputElement.value = this.inputElement.value.trim();
        if (this.inputElement.value.length === 0) {
            this.emptyUserInput = true;
            this.inputElement.focus();
            return;
        }
        this.emitValue();
    }

    emitValue() {
        this.inputText.emit(this.inputElement.value);
    }

    render() {
        return (
            <Host class={this.disabled ? "is-disabled" : ""}>
                <label
                    htmlFor={this.formName}
                    class="label-text"
                    innerHTML={this.formName}
                    data-german={this.germanTitle}
                ></label>
                <textarea rows={5} cols={50} data-german={this.germanTitle} />
                {this.infoString ? (
                    <div class="info">
                        <p innerHTML={this.infoString} />
                    </div>
                ) : (
                    ""
                )}
            </Host>
        );
    }
}